import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[draScrollTo]'
})
export class DraScrollToDirective implements OnInit{

  constructor(private element: ElementRef) {
  }
  ngOnInit() {
    // loadImage(this.element.nativeElement, this.imageUrl);
  }
  @Input('draScrollTo') private set draScrollTo(value) {
    if (!value) return;

    let element = this.element.nativeElement;
    element.parentElement.scrollTop = element.offsetTop;
  }
}



// WEBPACK FOOTER //
// ./src/directives/dra-scroll-to.directive.ts